import React from 'react';
import styled from 'styled-components';
import { StyledCModal } from '../Modals';
import { closeActiveModal } from '../../helper/modals';
import { modalContentV2ShellStyles } from './modalV2ShellStyles';

const StyledCModalCardV2 = styled(StyledCModal)`
  ${modalContentV2ShellStyles}
`;

export const StyledModalCardV2 = ({
  onClose,
  contentPadding = '0',
  elevated = false,
  footerPadding,
  dialogMaxWidth,
  footerStacked = false,
  closeOnBackdrop = false,
  ...props
}) => (
  <StyledCModalCardV2
    closeOnBackdrop={closeOnBackdrop}
    onClose={onClose ?? closeActiveModal}
    $contentPadding={contentPadding}
    $elevated={elevated}
    $footerPadding={footerPadding}
    $dialogMaxWidth={dialogMaxWidth}
    $footerStacked={footerStacked}
    {...props}
  />
);
